function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "TeacherAvatar",
  transform: "translate(-1243 -290)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_427",
  "data-name": "Path 427",
  fill: "#2c3e50",
  d: "M428.767,423.008a.969.969,0,0,1-.191-.019.982.982,0,0,1-.183-.056,1.03,1.03,0,0,1-.169-.09,1.1,1.1,0,0,1-.148-.121,1.012,1.012,0,0,1-.211-.317,1.013,1.013,0,0,1-.056-.183.992.992,0,0,1,0-.382.99.99,0,0,1,.056-.183,1,1,0,0,1,.09-.169.98.98,0,0,1,.121-.148,1.021,1.021,0,0,1,.148-.121,1.034,1.034,0,0,1,.169-.09.988.988,0,0,1,.183-.056.966.966,0,0,1,.382,0,.988.988,0,0,1,.182.056,1.026,1.026,0,0,1,.169.09.949.949,0,0,1,.27.269,1,1,0,0,1,.09.169.976.976,0,0,1,.056.183.962.962,0,0,1,.019.19.985.985,0,0,1-.285.691.982.982,0,0,1-.317.211.987.987,0,0,1-.183.056A.967.967,0,0,1,428.767,423.008Z",
  transform: "translate(853.195 -89.936)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_428",
  "data-name": "Path 428",
  fill: "#2c3e50",
  d: "M65.187,423.01a.966.966,0,0,1-.19-.019.986.986,0,0,1-.183-.056.969.969,0,0,1-.528-.528.985.985,0,0,1-.056-.183.943.943,0,0,1,0-.382.986.986,0,0,1,.056-.183.964.964,0,0,1,.09-.169.934.934,0,0,1,.121-.148.983.983,0,0,1,.148-.121,1.043,1.043,0,0,1,.169-.09.972.972,0,0,1,1.186.359.964.964,0,0,1,.09.169.986.986,0,0,1,.056.183.97.97,0,0,1,.02.19.975.975,0,0,1-.978.977Z",
  transform: "translate(1181.269 -89.939)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_429",
  "data-name": "Path 429",
  fill: "#ffe07d",
  d: "M125.205,80.809,111.05,91.36l3.252,23.653h21.825l3.25-23.64Z",
  transform: "translate(1139.003 217.082)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_133",
  "data-name": "Ellipse 133",
  fill: "#fa930d",
  cx: 6.589,
  cy: 6.589,
  r: 6.589,
  transform: "translate(1257.628 306.943)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_430",
  "data-name": "Path 430",
  fill: "#2c3e50",
  d: "M186.193,178.641a7.565,7.565,0,1,1,7.565-7.565A7.574,7.574,0,0,1,186.193,178.641Zm0-13.177a5.612,5.612,0,1,0,5.612,5.612A5.618,5.618,0,0,0,186.193,165.464Z",
  transform: "translate(1078.024 142.457)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_134",
  "data-name": "Ellipse 134",
  fill: "#ffde75",
  cx: 2.644,
  cy: 2.644,
  r: 2.644,
  transform: "translate(1261.573 323.93)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_431",
  "data-name": "Path 431",
  fill: "#2c3e50",
  d: "M222.643,344.679a3.62,3.62,0,1,1,3.62-3.62A3.624,3.624,0,0,1,222.643,344.679Zm0-5.287a1.667,1.667,0,1,0,1.667,1.667A1.669,1.669,0,0,0,222.643,339.392Z",
  transform: "translate(1041.574 -14.486)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_432",
  "data-name": "Path 432",
  fill: "#365e7d",
  d: "M87.285,30.5,69.062,16.915,50.84,30.5l-2.009-4.906L69.062,10,89.294,25.592Z",
  transform: "translate(1195.146 280.977)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_544",
  "data-name": "Rectangle 544",
  fill: "#fa930d",
  width: 6.335,
  height: 6.928,
  transform: "translate(1261.041 332.095)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_433",
  "data-name": "Path 433",
  fill: "#3a3d47",
  d: "M80.866,15.795,60.634.2a.977.977,0,0,0-1.192,0L39.211,15.795a.976.976,0,0,0-.308,1.144l2.009,4.906a.976.976,0,0,0,1.487.413l2.742-2.043,2.874,20.9H46.049a.977.977,0,1,0,0,1.953h9.845v5.952a.977.977,0,0,0,.977.977h6.335a.977.977,0,0,0,.977-.977V43.072h9.845a.977.977,0,1,0,0-1.953H72.08l2.872-20.892,2.725,2.031a.976.976,0,0,0,1.487-.413l2.009-4.906A.976.976,0,0,0,80.866,15.795ZM62.229,48.047H57.847V43.072h4.382Zm7.879-6.928H49.986L46.929,18.881,60.038,9.109l13.126,9.784Zm7.726-21.18-3.041-2.266h0L60.622,7.108a.992.992,0,0,0-.091-.06.976.976,0,0,0-1.009.014c-.023.014-.045.029-.066.045L42.242,19.938l-1.249-3.051L60.038,2.209,79.084,16.887Z",
  transform: "translate(1204.17 290)"
}));

var SvgTeacherAvatar = function SvgTeacherAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42.416 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeacherAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teacher-avatar.91e5eb46.svg";
export { ForwardRef as ReactComponent };